// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__gniw1","content":"RecentSearches_content__2hD3D"};